
// Sports data for the coach profile form
export const SPORTS_LIST = [
  'Archery',
  'Badminton', 
  'Baseball',
  'Basketball',
  'Bossaball',
  'Bowling',
  'Boxing',
  'Cheerleading',
  'Climbing',
  'Cricket',
  'Cross Country',
  'Cycling',
  'Dance',
  'Esports',
  'Field Hockey',
  'Figure Skating',
  'Football',
  'FootGolf',
  'Golf',
  'Gymnastics',
  'Hockey',
  'Lacrosse',
  'Martial Arts',
  'Pickleball',
  'Rowing',
  'Rugby',
  'Sailing',
  'Skateboarding',
  'Skiing',
  'Soccer',
  'Softball',
  'Surfing',
  'Swimming',
  'Table Tennis',
  'Tennis',
  'Track & Field',
  'Ultimate Frisbee',
  'Volleyball',
  'Water Polo',
  'Wrestling',
  'Other'
];

export const COACH_TYPES = [
  'Head Coach',
  'Assistant Coach',
  'Offensive Coach',
  'Defensive Coach',
  'Special Teams Coach',
  'Position Coach',
  'Skills Coach',
  'Strength & Conditioning Coach',
  'Youth Coach',
  'Volunteer Coach',
  'Private Coach',
  'Team Coach',
  'Individual Coach',
  'Hitting Coach',
  'Pitching Coach',
  'Goalie Coach',
  'Shooting Coach',
  'Technique Coach',
  'Strategy Coach',
  'Mental Performance Coach',
  'Nutritional Coach',
  'Recovery Coach',
  'Other'
];

export const COACHING_STYLES = [
  'Authoritative',
  'Democratic',
  'Holistic',
  'Autocratic',
  'Laissez-faire',
  'Vision-focused',
  'Relationship-focused',
  'Task-focused',
  'Player Development',
  'Performance-focused',
  'Positive Reinforcement',
  'Constructive Criticism',
  'Motivational',
  'Technical',
  'Tactical',
  'Mental Training',
  'Team Building',
  'Individual Focus',
  'Game Strategy',
  'Skill Development',
  'Competitive Excellence',
  'Fun & Enjoyment',
  'Character Building',
  'Leadership Development'
];

export const SPECIALIZATIONS = [
  'Youth Development',
  'Elite Performance',
  'Injury Recovery',
  'Strength Training',
  'Cardio Training',
  'Flexibility Training',
  'Mental Training',
  'Team Building',
  'Leadership Development',
  'Game Strategy',
  'Skill Development',
  'Technique Improvement',
  'Competition Preparation',
  'Sports Psychology',
  'Nutrition Coaching',
  'Recovery Techniques',
  'Equipment Training',
  'Safety Training',
  'Rules & Regulations',
  'Officiating',
  'Video Analysis',
  'Performance Analytics',
  'Recruitment',
  'Scholarship Guidance',
  'Career Development',
  'Parent Communication',
  'Team Management',
  'Budget Management',
  'Event Organization',
  'Media Relations',
  'Community Outreach',
  'Volunteer Management',
  'Fundraising',
  'Facility Management',
  'Equipment Management',
  'Travel Coordination',
  'Academic Support',
  'Life Skills Training',
  'Character Development',
  'Diversity & Inclusion',
  'Special Needs Athletes',
  'Adaptive Sports',
  'Technology Integration',
  'Social Media Management',
  'Brand Development',
  'Sponsorship Management',
  'Legal Compliance',
  'Risk Management',
  'Emergency Response',
  'First Aid & CPR',
  'Other'
];

// Sport-specific coach types
export const getSportSpecificCoachTypes = (sport: string): string[] => {
  const sportSpecificTypes: { [key: string]: string[] } = {
    'Football': [
      'Head Coach',
      'Offensive Coordinator',
      'Defensive Coordinator',
      'Special Teams Coach',
      'Quarterback Coach',
      'Running Back Coach',
      'Wide Receiver Coach',
      'Offensive Line Coach',
      'Defensive Line Coach',
      'Linebacker Coach',
      'Defensive Back Coach',
      'Strength & Conditioning Coach',
      'Position Coach'
    ],
    'Basketball': [
      'Head Coach',
      'Assistant Coach',
      'Player Development Coach',
      'Shooting Coach',
      'Skills Coach',
      'Strength & Conditioning Coach',
      'Youth Coach',
      'AAU Coach',
      'Private Coach'
    ],
    'Baseball': [
      'Head Coach',
      'Pitching Coach',
      'Hitting Coach',
      'Fielding Coach',
      'Base Running Coach',
      'Bullpen Coach',
      'Bench Coach',
      'Strength & Conditioning Coach',
      'Youth Coach',
      'Travel Ball Coach'
    ],
    'Soccer': [
      'Head Coach',
      'Assistant Coach',
      'Goalkeeper Coach',
      'Technical Coach',
      'Tactical Coach',
      'Youth Coach',
      'Academy Coach',
      'Club Coach',
      'Private Coach'
    ],
    'Tennis': [
      'Head Coach',
      'Private Coach',
      'Academy Coach',
      'Junior Coach',
      'High Performance Coach',
      'Technique Coach',
      'Mental Performance Coach',
      'Fitness Coach'
    ],
    'Swimming': [
      'Head Coach',
      'Assistant Coach',
      'Stroke Coach',
      'Sprint Coach',
      'Distance Coach',
      'Age Group Coach',
      'Masters Coach',
      'Technique Coach'
    ],
    'Track & Field': [
      'Head Coach',
      'Sprints Coach',
      'Distance Coach',
      'Hurdles Coach',
      'Jumps Coach',
      'Throws Coach',
      'Multi-Events Coach',
      'Strength Coach'
    ],
    'Volleyball': [
      'Head Coach',
      'Assistant Coach',
      'Setter Coach',
      'Hitting Coach',
      'Defensive Coach',
      'Serving Coach',
      'Youth Coach',
      'Club Coach'
    ],
    'Hockey': [
      'Head Coach',
      'Assistant Coach',
      'Goalie Coach',
      'Skating Coach',
      'Power Play Coach',
      'Penalty Kill Coach',
      'Skills Coach',
      'Youth Coach'
    ],
    'Golf': [
      'Head Coach',
      'Swing Coach',
      'Putting Coach',
      'Short Game Coach',
      'Mental Coach',
      'Junior Coach',
      'College Coach',
      'Private Instructor'
    ]
  };

  return sportSpecificTypes[sport] || COACH_TYPES;
};

export const AVAILABILITY_DAYS = [
  'Monday',
  'Tuesday', 
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
];

export const AVAILABILITY_TIMES = [
  'Morning (6AM-12PM)',
  'Afternoon (12PM-6PM)',
  'Evening (6PM-10PM)',
  'Weekend Only',
  'Flexible',
  'By Appointment'
];
